import * as actionTypes from "./actionTypes";

const initialState = {
  searchResult: null,
  searchResultStatus: false,
  keyword: "",
};

const globalSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_GLOBAL_SEARCH_RESULT:
      return {
        ...state,
        searchResult: null,
        searchResultStatus: false,
      };
    case actionTypes.FETCH_GLOBAL_SEARCH_RESULT_SUCCESS:
      console.log("action.payload", action.payload);
      return {
        ...state,
        searchResult: action.payload.data,
        searchResultStatus: true,
        keyword: action.payload.keyword,
      };
    case actionTypes.FETCH_GLOBAL_SEARCH_RESULT_FAILED:
      return {
        ...state,
        searchResult: null,
        searchResultStatus: true,
      };
    default:
      return state;
  }
};

export default globalSearchReducer;
